import React from 'react';
import { Icon, Divider, Row, Col } from 'antd';
import { Line } from '@antv/g2plot';

import { Scene, PointLayer, Scale, Zoom } from '@antv/l7';
import { GaodeMap } from '@antv/l7-maps';
import SSAS from '../../scripts/ssas'
import 'antd/dist/antd.css';
import './dataView.css';
import '../../scripts/config'

let $this;
class DataViewThreePage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            selectNode: null,
            data0: [
                {
                    "id": "53010200101",
                    "name": "建工新村",
                    "longitude": 102.691826,
                    "latitude": 25.039911,
                    "unit_price": 260,
                    "count": 26,
                    "yellow": 1,
                    "orange": 1,
                    "red": 1,
                    "purple": 0,
                    "color": 'green'
                },
                {
                    "id": "53010200101",
                    "name": "翠峰里",
                    "longitude": 102.68512,
                    "latitude": 25.040154,
                    "unit_price": 420,
                    "count": 42,
                    "yellow": 2,
                    "orange": 0,
                    "red": 0,
                    "purple": 0,
                    "color": 'green'
                },
                {
                    "id": "53010200101",
                    "name": "丹平里",
                    "longitude": 102.685233,
                    "latitude": 25.038327,
                    "unit_price": 560,
                    "count": 56,
                    "yellow": 13,
                    "orange": 3,
                    "red": 1,
                    "purple": 0,
                    "color": 'yellow'
                },
                {
                    "id": "53010200101",
                    "name": "丹宁里",
                    "longitude": 102.687212,
                    "latitude": 25.038234,
                    "unit_price": 390,
                    "count": 39,
                    "yellow": 10,
                    "orange": 9,
                    "red": 8,
                    "purple": 0,
                    "color": 'red'
                },
                {
                    "id": "53010200101",
                    "name": "棕树营",
                    "longitude": 102.683564,
                    "latitude": 25.04046,
                    "unit_price": 130,
                    "count": 13,
                    "yellow": 6,
                    "orange": 4,
                    "red": 0,
                    "purple": 0,
                    "color": 'orange'
                },
                {
                    "id": "53010200101",
                    "name": "棕树营",
                    "longitude": 102.684305,
                    "latitude": 25.041914,
                    "unit_price": 440,
                    "count": 44,
                    "yellow": 13,
                    "orange": 2,
                    "red": 4,
                    "purple": 1,
                    "color": 'purple'
                },
                {
                    "id": "53010200101",
                    "name": "晴沙里",
                    "longitude": 102.681247,
                    "latitude": 25.039522,
                    "unit_price": 560,
                    "count": 56,
                    "yellow": 4,
                    "orange": 0,
                    "red": 0,
                    "purple": 0,
                    "color": 'green'
                },
                {
                    "id": "53010200101",
                    "name": "中心组团",
                    "longitude": 102.682888,
                    "latitude": 25.039245,
                    "unit_price": 560,
                    "count": 56,
                    "yellow": 6,
                    "orange": 2,
                    "red": 0,
                    "purple": 0,
                    "color": 'green'
                },
                {
                    "id": "53010200101",
                    "name": "大理公馆",
                    "longitude": 102.678948,
                    "latitude": 25.048224,
                    "unit_price": 380,
                    "count": 38,
                    "yellow": 2,
                    "orange": 1,
                    "red": 0,
                    "purple": 0,
                    "color": 'green'
                },
                {
                    "id": "53010200101",
                    "name": "云投景苑",
                    "longitude": 102.679678,
                    "latitude": 25.041031,
                    "unit_price": 420,
                    "count": 42,
                    "yellow": 5,
                    "orange": 0,
                    "red": 1,
                    "purple": 0,
                    "color": 'green'
                },
                {
                    "id": "53010200101",
                    "name": "白马小区",
                    "longitude": 102.676845,
                    "latitude": 25.035004,
                    "unit_price": 380,
                    "count": 38,
                    "yellow": 13,
                    "orange": 4,
                    "red": 2,
                    "purple": 0,
                    "color": 'yellow'
                },
                {
                    "id": "53010200101",
                    "name": "船房小区",
                    "longitude": 102.688819,
                    "latitude": 25.024428,
                    "unit_price": 520,
                    "count": 52,
                    "yellow": 17,
                    "orange": 11,
                    "red": 9,
                    "purple": 0,
                    "color": 'red'
                },
                {
                    "id": "53010200101",
                    "name": "西华小区",
                    "longitude": 102.682853,
                    "latitude": 25.0289,
                    "unit_price": 490,
                    "count": 49,
                    "yellow": 16,
                    "orange": 22,
                    "red": 1,
                    "purple": 0,
                    "color": 'orange'
                },
                {
                    "id": "53010200101",
                    "name": "中央丽城",
                    "longitude": 102.704182,
                    "latitude": 25.024233,
                    "unit_price": 360,
                    "count": 36,
                    "yellow": 4,
                    "orange": 1,
                    "red": 0,
                    "purple": 0,
                    "color": 'green'
                }

            ],
            data1: [
                { time: '2020-05', value: 5, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-06', value: 9, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-07', value: 5, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-08', value: 2, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-09', value: 0, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-10', value: 3, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-11', value: 1, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2020-12', value: 0, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2021-01', value: 2, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2021-02', value: 5, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2021-03', value: 3, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },
                { time: '2021-04', value: 1, type: '血小板减少(＜30×109/L）或进行性下降或伴有出血倾向' },

                { time: '2020-05', value: 16, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-06', value: 11, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-07', value: 9, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-08', value: 3, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-09', value: 2, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-10', value: 0, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-11', value: 6, type: '重度贫血（Hb≤40g/L）' },
                { time: '2020-12', value: 2, type: '重度贫血（Hb≤40g/L）' },
                { time: '2021-01', value: 4, type: '重度贫血（Hb≤40g/L）' },
                { time: '2021-02', value: 8, type: '重度贫血（Hb≤40g/L）' },
                { time: '2021-03', value: 5, type: '重度贫血（Hb≤40g/L）' },
                { time: '2021-04', value: 3, type: '重度贫血（Hb≤40g/L）' },

                { time: '2020-05', value: 1, type: '梅毒' },
                { time: '2020-06', value: 1, type: '梅毒' },
                { time: '2020-07', value: 9, type: '梅毒' },
                { time: '2020-08', value: 1, type: '梅毒' },
                { time: '2020-09', value: 2, type: '梅毒' },
                { time: '2020-10', value: 5, type: '梅毒' },
                { time: '2020-11', value: 3, type: '梅毒' },
                { time: '2020-12', value: 2, type: '梅毒' },
                { time: '2021-01', value: 0, type: '梅毒' },
                { time: '2021-02', value: 1, type: '梅毒' },
                { time: '2021-03', value: 2, type: '梅毒' },
                { time: '2021-04', value: 0, type: '梅毒' },

                { time: '2020-05', value: 0, type: 'HIV感染及AIDS' },
                { time: '2020-06', value: 2, type: 'HIV感染及AIDS' },
                { time: '2020-07', value: 0, type: 'HIV感染及AIDS' },
                { time: '2020-08', value: 1, type: 'HIV感染及AIDS' },
                { time: '2020-09', value: 0, type: 'HIV感染及AIDS' },
                { time: '2020-10', value: 2, type: 'HIV感染及AIDS' },
                { time: '2020-11', value: 3, type: 'HIV感染及AIDS' },
                { time: '2020-12', value: 1, type: 'HIV感染及AIDS' },
                { time: '2021-01', value: 0, type: 'HIV感染及AIDS' },
                { time: '2021-02', value: 0, type: 'HIV感染及AIDS' },
                { time: '2021-03', value: 2, type: 'HIV感染及AIDS' },
                { time: '2021-04', value: 1, type: 'HIV感染及AIDS' },

                { time: '2020-05', value: 18, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-06', value: 21, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-07', value: 11, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-08', value: 9, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-09', value: 0, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-10', value: 8, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-11', value: 0, type: '妊娠期糖尿病(GDM)' },
                { time: '2020-12', value: 10, type: '妊娠期糖尿病(GDM)' },
                { time: '2021-01', value: 14, type: '妊娠期糖尿病(GDM)' },
                { time: '2021-02', value: 5, type: '妊娠期糖尿病(GDM)' },
                { time: '2021-03', value: 2, type: '妊娠期糖尿病(GDM)' },
                { time: '2021-04', value: 0, type: '妊娠期糖尿病(GDM)' },

                { time: '2020-05', value: 8, type: '乙肝大小三阳' },
                { time: '2020-06', value: 3, type: '乙肝大小三阳' },
                { time: '2020-07', value: 0, type: '乙肝大小三阳' },
                { time: '2020-08', value: 0, type: '乙肝大小三阳' },
                { time: '2020-09', value: 3, type: '乙肝大小三阳' },
                { time: '2020-10', value: 1, type: '乙肝大小三阳' },
                { time: '2020-11', value: 0, type: '乙肝大小三阳' },
                { time: '2020-12', value: 1, type: '乙肝大小三阳' },
                { time: '2021-01', value: 3, type: '乙肝大小三阳' },
                { time: '2021-02', value: 0, type: '乙肝大小三阳' },
                { time: '2021-03', value: 0, type: '乙肝大小三阳' },
                { time: '2021-04', value: 1, type: '乙肝大小三阳' },
            ],
            data2: [
                { time: '2020-05', value: 5, type: '自然流产' },
                { time: '2020-06', value: 6, type: '自然流产' },
                { time: '2020-07', value: 2, type: '自然流产' },
                { time: '2020-08', value: 11, type: '自然流产' },
                { time: '2020-09', value: 8, type: '自然流产' },
                { time: '2020-10', value: 4, type: '自然流产' },
                { time: '2020-11', value: 0, type: '自然流产' },
                { time: '2020-12', value: 12, type: '自然流产' },
                { time: '2021-01', value: 4, type: '自然流产' },
                { time: '2021-02', value: 1, type: '自然流产' },
                { time: '2021-03', value: 2, type: '自然流产' },
                { time: '2021-04', value: 0, type: '自然流产' },

                { time: '2020-05', value: 15, type: '人工流产' },
                { time: '2020-06', value: 2, type: '人工流产' },
                { time: '2020-07', value: 0, type: '人工流产' },
                { time: '2020-08', value: 8, type: '人工流产' },
                { time: '2020-09', value: 4, type: '人工流产' },
                { time: '2020-10', value: 1, type: '人工流产' },
                { time: '2020-11', value: 3, type: '人工流产' },
                { time: '2020-12', value: 0, type: '人工流产' },
                { time: '2021-01', value: 14, type: '人工流产' },
                { time: '2021-02', value: 8, type: '人工流产' },
                { time: '2021-03', value: 6, type: '人工流产' },
                { time: '2021-04', value: 7, type: '人工流产' },

                { time: '2020-05', value: 31, type: '分娩' },
                { time: '2020-06', value: 28, type: '分娩' },
                { time: '2020-07', value: 42, type: '分娩' },
                { time: '2020-08', value: 16, type: '分娩' },
                { time: '2020-09', value: 9, type: '分娩' },
                { time: '2020-10', value: 23, type: '分娩' },
                { time: '2020-11', value: 17, type: '分娩' },
                { time: '2020-12', value: 12, type: '分娩' },
                { time: '2021-01', value: 11, type: '分娩' },
                { time: '2021-02', value: 27, type: '分娩' },
                { time: '2021-03', value: 19, type: '分娩' },
                { time: '2021-04', value: 8, type: '分娩' },

                { time: '2020-05', value: 1, type: '失联' },
                { time: '2020-06', value: 0, type: '失联' },
                { time: '2020-07', value: 0, type: '失联' },
                { time: '2020-08', value: 0, type: '失联' },
                { time: '2020-09', value: 0, type: '失联' },
                { time: '2020-10', value: 0, type: '失联' },
                { time: '2020-11', value: 0, type: '失联' },
                { time: '2020-12', value: 0, type: '失联' },
                { time: '2021-01', value: 2, type: '失联' },
                { time: '2021-02', value: 0, type: '失联' },
                { time: '2021-03', value: 0, type: '失联' },
                { time: '2021-04', value: 0, type: '失联' }
            ],
            data3: [
                { time: '2020-05', value: 0, type: '＜18岁' },
                { time: '2020-06', value: 2, type: '＜18岁' },
                { time: '2020-07', value: 1, type: '＜18岁' },
                { time: '2020-08', value: 0, type: '＜18岁' },
                { time: '2020-09', value: 0, type: '＜18岁' },
                { time: '2020-10', value: 0, type: '＜18岁' },
                { time: '2020-11', value: 0, type: '＜18岁' },
                { time: '2020-12', value: 2, type: '＜18岁' },
                { time: '2021-01', value: 0, type: '＜18岁' },
                { time: '2021-02', value: 4, type: '＜18岁' },
                { time: '2021-03', value: 2, type: '＜18岁' },
                { time: '2021-04', value: 1, type: '＜18岁' },

                { time: '2020-05', value: 36, type: '18-35岁' },
                { time: '2020-06', value: 21, type: '18-35岁' },
                { time: '2020-07', value: 42, type: '18-35岁' },
                { time: '2020-08', value: 51, type: '18-35岁' },
                { time: '2020-09', value: 16, type: '18-35岁' },
                { time: '2020-10', value: 23, type: '18-35岁' },
                { time: '2020-11', value: 34, type: '18-35岁' },
                { time: '2020-12', value: 28, type: '18-35岁' },
                { time: '2021-01', value: 19, type: '18-35岁' },
                { time: '2021-02', value: 32, type: '18-35岁' },
                { time: '2021-03', value: 25, type: '18-35岁' },
                { time: '2021-04', value: 21, type: '18-35岁' },

                { time: '2020-05', value: 21, type: '35-40岁' },
                { time: '2020-06', value: 18, type: '35-40岁' },
                { time: '2020-07', value: 20, type: '35-40岁' },
                { time: '2020-08', value: 11, type: '35-40岁' },
                { time: '2020-09', value: 6, type: '35-40岁' },
                { time: '2020-10', value: 14, type: '35-40岁' },
                { time: '2020-11', value: 10, type: '35-40岁' },
                { time: '2020-12', value: 8, type: '35-40岁' },
                { time: '2021-01', value: 17, type: '35-40岁' },
                { time: '2021-02', value: 7, type: '35-40岁' },
                { time: '2021-03', value: 9, type: '35-40岁' },
                { time: '2021-04', value: 6, type: '35-40岁' },

                { time: '2020-05', value: 5, type: '≥40岁' },
                { time: '2020-06', value: 1, type: '≥40岁' },
                { time: '2020-07', value: 0, type: '≥40岁' },
                { time: '2020-08', value: 2, type: '≥40岁' },
                { time: '2020-09', value: 1, type: '≥40岁' },
                { time: '2020-10', value: 4, type: '≥40岁' },
                { time: '2020-11', value: 0, type: '≥40岁' },
                { time: '2020-12', value: 3, type: '≥40岁' },
                { time: '2021-01', value: 6, type: '≥40岁' },
                { time: '2021-02', value: 2, type: '≥40岁' },
                { time: '2021-03', value: 8, type: '≥40岁' },
                { time: '2021-04', value: 0, type: '≥40岁' }
            ],
            data4: [
                { time: '2020-05', value: 58, type: '一胎' },
                { time: '2020-06', value: 37, type: '一胎' },
                { time: '2020-07', value: 48, type: '一胎' },
                { time: '2020-08', value: 24, type: '一胎' },
                { time: '2020-09', value: 19, type: '一胎' },
                { time: '2020-10', value: 33, type: '一胎' },
                { time: '2020-11', value: 27, type: '一胎' },
                { time: '2020-12', value: 38, type: '一胎' },
                { time: '2021-01', value: 19, type: '一胎' },
                { time: '2021-02', value: 8, type: '一胎' },
                { time: '2021-03', value: 16, type: '一胎' },
                { time: '2021-04', value: 24, type: '一胎' },

                { time: '2020-05', value: 24, type: '二胎' },
                { time: '2020-06', value: 15, type: '二胎' },
                { time: '2020-07', value: 7, type: '二胎' },
                { time: '2020-08', value: 18, type: '二胎' },
                { time: '2020-09', value: 5, type: '二胎' },
                { time: '2020-10', value: 2, type: '二胎' },
                { time: '2020-11', value: 3, type: '二胎' },
                { time: '2020-12', value: 9, type: '二胎' },
                { time: '2021-01', value: 11, type: '二胎' },
                { time: '2021-02', value: 7, type: '二胎' },
                { time: '2021-03', value: 13, type: '二胎' },
                { time: '2021-04', value: 5, type: '二胎' },

                { time: '2020-05', value: 1, type: '三胎' },
                { time: '2020-06', value: 0, type: '三胎' },
                { time: '2020-07', value: 0, type: '三胎' },
                { time: '2020-08', value: 2, type: '三胎' },
                { time: '2020-09', value: 0, type: '三胎' },
                { time: '2020-10', value: 0, type: '三胎' },
                { time: '2020-11', value: 0, type: '三胎' },
                { time: '2020-12', value: 1, type: '三胎' },
                { time: '2021-01', value: 0, type: '三胎' },
                { time: '2021-02', value: 1, type: '三胎' },
                { time: '2021-03', value: 1, type: '三胎' },
                { time: '2021-04', value: 2, type: '三胎' },

                { time: '2020-05', value: 1, type: '三胎以上' },
                { time: '2020-06', value: 2, type: '三胎以上' },
                { time: '2020-07', value: 0, type: '三胎以上' },
                { time: '2020-08', value: 1, type: '三胎以上' },
                { time: '2020-09', value: 3, type: '三胎以上' },
                { time: '2020-10', value: 2, type: '三胎以上' },
                { time: '2020-11', value: 0, type: '三胎以上' },
                { time: '2020-12', value: 0, type: '三胎以上' },
                { time: '2021-01', value: 0, type: '三胎以上' },
                { time: '2021-02', value: 1, type: '三胎以上' },
                { time: '2021-03', value: 2, type: '三胎以上' },
                { time: '2021-04', value: 0, type: '三胎以上' }
            ],
            data5: [
                { time: '2020-05', value: 68, type: '筛查人次' },
                { time: '2020-06', value: 48, type: '筛查人次' },
                { time: '2020-07', value: 36, type: '筛查人次' },
                { time: '2020-08', value: 51, type: '筛查人次' },
                { time: '2020-09', value: 37, type: '筛查人次' },
                { time: '2020-10', value: 49, type: '筛查人次' },
                { time: '2020-11', value: 19, type: '筛查人次' },
                { time: '2020-12', value: 24, type: '筛查人次' },
                { time: '2021-01', value: 33, type: '筛查人次' },
                { time: '2021-02', value: 54, type: '筛查人次' },
                { time: '2021-03', value: 37, type: '筛查人次' },
                { time: '2021-04', value: 40, type: '筛查人次' },

                { time: '2020-05', value: 5, type: '梅毒确诊' },
                { time: '2020-06', value: 1, type: '梅毒确诊' },
                { time: '2020-07', value: 0, type: '梅毒确诊' },
                { time: '2020-08', value: 0, type: '梅毒确诊' },
                { time: '2020-09', value: 3, type: '梅毒确诊' },
                { time: '2020-10', value: 1, type: '梅毒确诊' },
                { time: '2020-11', value: 0, type: '梅毒确诊' },
                { time: '2020-12', value: 2, type: '梅毒确诊' },
                { time: '2021-01', value: 1, type: '梅毒确诊' },
                { time: '2021-02', value: 0, type: '梅毒确诊' },
                { time: '2021-03', value: 0, type: '梅毒确诊' },
                { time: '2021-04', value: 1, type: '梅毒确诊' },

                { time: '2020-05', value: 2, type: 'HIV确诊' },
                { time: '2020-06', value: 1, type: 'HIV确诊' },
                { time: '2020-07', value: 0, type: 'HIV确诊' },
                { time: '2020-08', value: 0, type: 'HIV确诊' },
                { time: '2020-09', value: 0, type: 'HIV确诊' },
                { time: '2020-10', value: 1, type: 'HIV确诊' },
                { time: '2020-11', value: 0, type: 'HIV确诊' },
                { time: '2020-12', value: 2, type: 'HIV确诊' },
                { time: '2021-01', value: 1, type: 'HIV确诊' },
                { time: '2021-02', value: 0, type: 'HIV确诊' },
                { time: '2021-03', value: 1, type: 'HIV确诊' },
                { time: '2021-04', value: 0, type: 'HIV确诊' },

                { time: '2020-05', value: 2, type: '乙肝确诊' },
                { time: '2020-06', value: 4, type: '乙肝确诊' },
                { time: '2020-07', value: 1, type: '乙肝确诊' },
                { time: '2020-08', value: 4, type: '乙肝确诊' },
                { time: '2020-09', value: 3, type: '乙肝确诊' },
                { time: '2020-10', value: 2, type: '乙肝确诊' },
                { time: '2020-11', value: 0, type: '乙肝确诊' },
                { time: '2020-12', value: 0, type: '乙肝确诊' },
                { time: '2021-01', value: 1, type: '乙肝确诊' },
                { time: '2021-02', value: 3, type: '乙肝确诊' },
                { time: '2021-03', value: 0, type: '乙肝确诊' },
                { time: '2021-04', value: 2, type: '乙肝确诊' }
            ],
            data6: [
                { time: '2020-05', value: 54, type: '本县' },
                { time: '2020-06', value: 39, type: '本县' },
                { time: '2020-07', value: 28, type: '本县' },
                { time: '2020-08', value: 47, type: '本县' },
                { time: '2020-09', value: 39, type: '本县' },
                { time: '2020-10', value: 41, type: '本县' },
                { time: '2020-11', value: 20, type: '本县' },
                { time: '2020-12', value: 33, type: '本县' },
                { time: '2021-01', value: 18, type: '本县' },
                { time: '2021-02', value: 26, type: '本县' },
                { time: '2021-03', value: 29, type: '本县' },
                { time: '2021-04', value: 35, type: '本县' },

                { time: '2020-05', value: 15, type: '本市外县' },
                { time: '2020-06', value: 9, type: '本市外县' },
                { time: '2020-07', value: 7, type: '本市外县' },
                { time: '2020-08', value: 14, type: '本市外县' },
                { time: '2020-09', value: 5, type: '本市外县' },
                { time: '2020-10', value: 1, type: '本市外县' },
                { time: '2020-11', value: 0, type: '本市外县' },
                { time: '2020-12', value: 0, type: '本市外县' },
                { time: '2021-01', value: 6, type: '本市外县' },
                { time: '2021-02', value: 13, type: '本市外县' },
                { time: '2021-03', value: 5, type: '本市外县' },
                { time: '2021-04', value: 2, type: '本市外县' },

                { time: '2020-05', value: 3, type: '本省外市' },
                { time: '2020-06', value: 5, type: '本省外市' },
                { time: '2020-07', value: 1, type: '本省外市' },
                { time: '2020-08', value: 3, type: '本省外市' },
                { time: '2020-09', value: 0, type: '本省外市' },
                { time: '2020-10', value: 0, type: '本省外市' },
                { time: '2020-11', value: 0, type: '本省外市' },
                { time: '2020-12', value: 1, type: '本省外市' },
                { time: '2021-01', value: 1, type: '本省外市' },
                { time: '2021-02', value: 0, type: '本省外市' },
                { time: '2021-03', value: 2, type: '本省外市' },
                { time: '2021-04', value: 0, type: '本省外市' },

                { time: '2020-05', value: 4, type: '外省' },
                { time: '2020-06', value: 0, type: '外省' },
                { time: '2020-07', value: 1, type: '外省' },
                { time: '2020-08', value: 0, type: '外省' },
                { time: '2020-09', value: 2, type: '外省' },
                { time: '2020-10', value: 0, type: '外省' },
                { time: '2020-11', value: 0, type: '外省' },
                { time: '2020-12', value: 0, type: '外省' },
                { time: '2021-01', value: 6, type: '外省' },
                { time: '2021-02', value: 2, type: '外省' },
                { time: '2021-03', value: 1, type: '外省' },
                { time: '2021-04', value: 7, type: '外省' }
            ]
        }
        $this = this;
    };
    //组件载入完成
    componentDidMount() {
        this.mapInit();
        this.chartTwoInit();
        this.chartThreeInit();
        this.chartFourInit();
        this.chartFiveInit();
        this.chartSixInit();
        this.chartSevenInit();
    }
    mapInit = () => {
        const scene = new Scene({
            id: 'chartOnecontainer',
            map: new GaodeMap({
                style: 'dark',
                pitch: 0,
                center: [102.689079, 25.03978],
                zoom: 15,
                pitch: 60,
                viewMode: '3D', //开启3D视图,默认为关闭
                zooms: [10, 40],
            })
        });
        scene.on('loaded', () => {
            const data = this.state.data0;
            const pointLayer = new PointLayer({})
                .source(data, {
                    parser: {
                        type: 'json',
                        x: 'longitude',
                        y: 'latitude'
                    }
                })
                .shape('circle')
                .size('unit_price', [5, 25])
                .color('name', ['green', 'yellow', 'orange', 'red', 'purple'])
                .style({
                    opacity: 0.3,
                    strokeWidth: 1
                })
                .active({
                    color: '#ffffff',
                })
                .on('mousemove', (ev) => {
                    $this.setState({ selectNode: ev.feature, visible: true });
                })
                .on('mouseout', (ev) => {
                    setTimeout(() => {
                        $this.setState({ selectNode: {}, visible: false });
                    }, 400);
                });

            scene.addLayer(pointLayer);

            const zoomControl = new Zoom({
                position: 'topright'
            });
            const scaleControl = new Scale({
                position: 'bottomright'
            });
            scene.addControl(zoomControl);
            scene.addControl(scaleControl);
        });

    }
    chartTwoInit = () => {
        const data = this.state.data1;
        const linePlot = new Line('chartTwocontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 例`,
                },
            },
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }

    chartThreeInit = () => {
        const data = this.state.data2;
        const linePlot = new Line('chartThreecontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 人`,
                },
            },
            color: ['#F8D420', '#E50C25', '#0BF438', '#FFFFFF'],
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }
    chartFourInit = () => {
        const data = this.state.data3;
        const linePlot = new Line('chartFourcontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 人`,
                },
            },
            color: ['#F9F321', '#28F516', '#F29C2D', '#FB0634'],
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }

    chartFiveInit = () => {
        const data = this.state.data4;
        const linePlot = new Line('chartFivecontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 人`,
                },
            },
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }
    chartSixInit = () => {
        const data = this.state.data5;
        const linePlot = new Line('chartSixcontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 次`,
                },
            },
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }
    chartSevenInit = () => {
        const data = this.state.data6;
        const linePlot = new Line('chartSevencontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            yAxis: {
                label: {
                    formatter: (v) => `${v} 人`,
                },
            },
            legend: {
                position: 'bottom',
            },
            smooth: true,
            // @TODO 后续会换一种动画方式
            animation: {
                appear: {
                    animation: 'path-in',
                    duration: 5000,
                },
            },
        });

        linePlot.render();
    }
    render() {
        return (
            <div>
                <Row gutter={4} className="div-c-charts">
                    <Col span={12}>
                        <div className="div-c-charts-content-center">
                            <div className="div-c-charts-content-title"><Icon type='global'></Icon><Divider type='vertical'></Divider>地域分布</div>
                            {
                                this.state.visible ?
                                    <Row className='div-c-charts-notice' style={{ borderColor: this.state.selectNode.color || '#FFFFFF' }}>
                                        <Col span={24}>地名：{this.state.selectNode.name || '未知'}</Col>
                                        <Col span={24}>在管孕产妇：{SSAS.pubDefaultValue(this.state.selectNode.count, 'number', '人')}</Col>
                                        <Col span={24}>黄色妊娠风险：{SSAS.pubDefaultValue(this.state.selectNode.yellow, 'number', '人')}</Col>
                                        <Col span={24}>橙色妊娠风险：{SSAS.pubDefaultValue(this.state.selectNode.orange, 'number', '人')}</Col>
                                        <Col span={24}>红色妊娠风险：{SSAS.pubDefaultValue(this.state.selectNode.red, 'number', '人')}</Col>
                                        <Col span={24}>紫色妊娠风险：{SSAS.pubDefaultValue(this.state.selectNode.purple, 'number', '人')}</Col>
                                    </Row>
                                    : null
                            }
                            <div className='div-c-charts-mapcontent'>
                                <div id='chartOnecontainer'></div>
                            </div>
                        </div>
                    </Col>
                    <Col span={12}>
                        <Row gutter={2}>
                            <Col span={24}>
                                <div className="div-c-charts-content">
                                    <div className="div-c-charts-content-title"><Icon type='alert'></Icon><Divider type='vertical'></Divider>高危因素分布</div>
                                    <div id='chartTwocontainer'></div>
                                </div>
                            </Col>
                            <Col span={24}>
                                <div className="div-c-charts-content">
                                    <div className="div-c-charts-content-title"><Icon type='file-done'></Icon><Divider type='vertical'></Divider>妊娠结果</div>
                                    <div id='chartThreecontainer'></div>
                                </div>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='smile'></Icon><Divider type='vertical'></Divider>孕妇年龄分布</div>
                            <div id='chartFourcontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='usergroup-add'></Icon><Divider type='vertical'></Divider>孕妇产次分布</div>
                            <div id='chartFivecontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='file-search'></Icon><Divider type='vertical'></Divider>三病筛查</div>
                            <div id='chartSixcontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='deployment-unit'></Icon><Divider type='vertical'></Divider>人群分布</div>
                            <div id='chartSevencontainer'></div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default DataViewThreePage;